import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function ContactPage() {
  const { t } = useLanguage();
  return (
    <div className="page-content">
      <div className="section-full content-inner-2 overlay-white-middle">
        <div className="container" style={{ maxWidth: 600, margin: '0 auto', padding: 24 }}>
          <div className="section-head text-center m-b50">
            <h2 className="m-b10" style={{ fontWeight: 'bold' }}>{t('contact.title') || 'Contacto'}</h2>
            <p>{t('contact.subtitle') || '¿Tienes alguna pregunta, sugerencia o necesitas ayuda? ¡Contáctanos!'}</p>
          </div>
          <form>
            <div className="form-group">
              <label htmlFor="nombre">{t('contact.name') || 'Nombre'}</label>
              <input type="text" className="form-control" id="nombre" name="nombre" required />
            </div>
            <div className="form-group">
              <label htmlFor="email">{t('contact.email') || 'Correo electrónico'}</label>
              <input type="email" className="form-control" id="email" name="email" required />
            </div>
            <div className="form-group">
              <label htmlFor="mensaje">{t('contact.message') || 'Mensaje'}</label>
              <textarea className="form-control" id="mensaje" name="mensaje" rows={5} required />
            </div>
            <button type="submit" className="btn btn-primary" style={{ marginTop: 16 }}>{t('contact.send') || 'Enviar'}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
